import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { JobService, JobType, LoginService } from '../..';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

@Component({
    selector: 'admin-jobtypes',
    templateUrl: './admin-jobtypes.component.html',
    styleUrls: ['./admin-jobtypes.component.scss'],
})
export class AdminJobTypesComponent implements OnInit {
    isLoading: boolean = false;
    allJobTypes: JobType[] | null;
    jobTypes: JobType[] | null;
    error: string | null;
    selectedJobType: JobType | null;
    showActive = true;
    showDialog = false;

    constructor(
        protected loginService: LoginService,
        private jobService: JobService,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this._loadUserGroups();

        // Register hotkey for "Add Group" (Ctrl + Shift + A)
        this.hotkeyService.registerHotkey('ctrl+shift+a', 'Add Group', () => {
            this.onClickToggle();
        });
    }

    onJobTypeSelected(jobType: JobType) {
        this.selectedJobType = jobType;
        this.showDialog = true;
    }

    onJobTypeUpdated(jobType: JobType) {
        this._loadUserGroups();
    }

    onStatus(status: string | 'active'): void {
        this._filter(status);
    }

    onClickToggle() {
        this.selectedJobType = null;
        this.showDialog = true;
    }

    private _filter(status: string) {
        this.jobTypes = this.allJobTypes.filter((u) => status === 'active' ? u.active : !u.active);
    }

    private _loadUserGroups() {
        this.isLoading = true;
        this.jobService
            .getAllJobTypes()
            .pipe(
                tap(response => {
                    this.allJobTypes = response;
                    this._filter('active');
                }))
            .subscribe({
                error: (err) => (this.error = err),
                complete: () => (this.isLoading = false)
            });
    }
}
